import { useLayoutEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EBetslipPage } from 'interfaces/bet-data';
import { getBetHistoryCount } from 'services/account-settings';
import { useBetslipConfigsContext } from 'newelements/_Betslip/providers/configs-provider';
import { setCashoutFrom, setOpenBetsCount } from 'store/actions';
import {
  getActiveTabPage,
  getBettedTrigger,
  getCashoutFrom,
  getOpenBetsCount,
  getTabs,
  getUpdateOpenBetsTrigger
} from 'store/selectors/betslip';
import { getIsLoggedIn } from 'store/selectors/user-data';

export const OpenBetManager = (): null => {
  const dispatch = useDispatch();

  const { floatingMode } = useBetslipConfigsContext().static;

  const tabs = useSelector(getTabs);
  // @Todo change pages check
  const page = useSelector(getActiveTabPage);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const doBetDone = useSelector(getBettedTrigger);
  const cashOutFrom = useSelector(getCashoutFrom);
  const openBetsCount = useSelector(getOpenBetsCount);
  const updateOpenBetsTrigger = useSelector(getUpdateOpenBetsTrigger);

  const floatingFirstUpdateOpenBets = useRef(floatingMode);

  const updateOpenBetsCount = (count: number) =>
    dispatch(setOpenBetsCount(count));

  const updateMyBets = () => getBetHistoryCount(updateOpenBetsCount);

  useLayoutEffect(() => {
    if (!isLoggedIn) {
      updateOpenBetsCount(0);
    }
  }, [isLoggedIn]);

  useLayoutEffect(() => {
    if (
      tabs.length > 1 &&
      openBetsCount === 0 &&
      cashOutFrom === 'betHistory'
    ) {
      dispatch(setCashoutFrom(''));
    } else if (page === EBetslipPage.BETSLIP && cashOutFrom === 'betHistory') {
      updateMyBets();
    }
  }, [cashOutFrom, openBetsCount]);

  useLayoutEffect(() => {
    if (floatingFirstUpdateOpenBets.current) {
      floatingFirstUpdateOpenBets.current = false;

      return;
    }

    if (isLoggedIn) {
      updateMyBets();
    } else {
      updateOpenBetsCount(0);
    }
  }, [doBetDone, isLoggedIn, updateOpenBetsTrigger]);

  return null;
};
